<template>
  <div role="dialog"
    v-bind:class="{
    'modal':true,
    'fade':effect === 'fade',
    'zoom':effect === 'zoom'
    }"
    >
    <div v-bind:class="{'modal-dialog':true,'modal-lg':large,'modal-sm':small,'modal-dialog-centered':centered}" role="document"
      v-bind:style="{width: optionalWidth}">
      <div class="modal-content">
        <slot name="modal-header">
          <div class="modal-header">
            <button type="button" class="close" @click="close"><span>&times;</span></button>
            <h4 class="modal-title" >{{title}}</h4>
          </div>
        </slot>
        <slot name="modal-body">
          <div class="modal-body"></div>
        </slot>
        <slot name="modal-footer">
          <div class="modal-footer">
            <button type="button" class="btn btn-default" @click="close">{{btnleft}}</button>
            <button type="button" class="btn btn-primary" @click="callback">{{btnright}}</button>
          </div>
        </slot>
      </div>
      <a v-if="indicators" @click="indicatorleft" class="left carousel-control" role="button" style="max-height: 50%;margin-top: 20%;"> 
        <span class="fa fa-arrow-left" aria-hidden="true" style="margin-top: 125%"></span>
      </a>
      <a v-if="indicators" @click="indicatorright" class="right carousel-control" role="button" style="max-height: 50%;margin-top: 20%;">
        <span class="fa fa-arrow-right" aria-hidden="true" style="margin-top: 125%"></span> 
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    show: {
      require: true,
      type: Boolean,
      twoWay: true
    },
    width: {
      default: null
    },
    callback: {
      type: Function,
      default () {}
    },
    effect: {
      type: String,
      default: null
    },
    backdrop: {
      type: Boolean,
      default: true
    },
    large: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    centered: {
      type: Boolean,
      default: false
    },
    btnright: {
      type: String
    },
    btnleft: {
      type: String
    },
    indicators: {
      type: Boolean,
      default: false
    },
    indicatorright: {
      type: Function,
      default () {}
    },
    indicatorleft: {
      type: Function,
      default () {}
    }
  },
  ready () {
    this.$watch('show', (val) => {
      const el = this.$el
      const body = document.body
      const scrollBarWidth = this.getScrollBarWidth()
      if (val) {
        el.querySelector('.modal-content').focus()
        el.style.display = 'block'
        setTimeout(() => el.classList.add('in'), 0)
        body.classList.add('modal-open')
        if (scrollBarWidth !== 0) {
          body.style.paddingRight = scrollBarWidth + 'px'
        }
        if (this.backdrop) {
          this._blurModalContentEvent = this.listen(this.$el, 'click', (e) => {
            if (e.target === el) this.show = false
          })
        }
      } else {
        if (this._blurModalContentEvent) this._blurModalContentEvent.remove()
        el.classList.remove('in')
        setTimeout(() => {
          el.style.display = 'none'
          body.classList.remove('modal-open')
          body.style.paddingRight = '0'
        }, 300)
      }
    }, { immediate: true })
  },
  computed: {
    optionalWidth: function () {
      if (this.width === null) {
        return null
      } else if (Number.isInteger(this.width)) {
        return this.width + 'px'
      }
      return this.width
    }
  },
  methods: {
    close () {
      this.show = false
    },
    listen (target, eventType, callback) {
      if (target.addEventListener) {
        target.addEventListener(eventType, callback, false)
        return {
          remove () {
            target.removeEventListener(eventType, callback, false)
          }
        }
      } else if (target.attachEvent) {
        target.attachEvent('on' + eventType, callback)
        return {
          remove () {
            target.detachEvent('on' + eventType, callback)
          }
        }
      }
    },
    getScrollBarWidth () {
      if (document.documentElement.scrollHeight <= document.documentElement.clientHeight) {
        return 0
      }
      let inner = document.createElement('p')
      inner.style.width = '100%'
      inner.style.height = '200px'
      let outer = document.createElement('div')
      outer.style.position = 'absolute'
      outer.style.top = '0px'
      outer.style.left = '0px'
      outer.style.visibility = 'hidden'
      outer.style.width = '200px'
      outer.style.height = '150px'
      outer.style.overflow = 'hidden'
      outer.appendChild(inner)
      document.body.appendChild(outer)
      let w1 = inner.offsetWidth
      outer.style.overflow = 'scroll'
      let w2 = inner.offsetWidth
      if (w1 === w2) w2 = outer.clientWidth
      document.body.removeChild(outer)
      return (w1 - w2)
    }
  }
}
</script>

<style>
.modal {
  transition: all 0.3s ease;
}
.modal.in {
  background-color: rgba(0,0,0,0);
}
.modal.zoom .modal-dialog {
    -webkit-transform: scale(0.1);
    -moz-transform: scale(0.1);
    -ms-transform: scale(0.1);
    transform: scale(0.1);
    top: 300px;
    opacity: 0;
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    transition: all 0.3s;
}
.modal.zoom.in .modal-dialog {
    -webkit-transform: scale(1);
    -moz-transform: scale(1);
    -ms-transform: scale(1);
    transform: scale(1);
    -webkit-transform: translate3d(0, -300px, 0);
    transform: translate3d(0, -300px, 0);
    opacity: 1;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - 1rem);
}

.modal-dialog-centered::before {
  display: block;
  height: calc(100vh - 1rem);
  content: "";
}

@media (min-width: 576px) {
  .modal-dialog-centered {
    min-height: calc(100% - 3.5rem);
  }
  .modal-dialog-centered::before {
    height: calc(100vh - 3.5rem);
  }
  .modal-sm {
    max-width: 300px;
  }
}
</style>



// WEBPACK FOOTER //
// Modal.vue?80f66d40